export const TIME = {
	TODAY: 1,
	'1HOUR': 2,
	'3HOURS': 3,
	'5HOURS': 4,
	WEEK: 5,
	ALL: 6,
};
